
import {Component, Prop, Vue} from 'vue-property-decorator';
import WaitlistItem from "@/classes/floor-map/WaitlistItem";
import {update} from "lodash-es";
import {WaitlistRepo} from "@/classes/repos/WaitlistRepo";

@Component<ItemColor>(
    {
      methods: {update}
    }
)
export default class ItemColor extends Vue {
  @Prop()
  data!: { item: WaitlistItem };

  styles = ['primary', 'warning', 'light'];

  async save(color: string) {
    this.data.item.item_color = color;
    await WaitlistRepo.change_item_color(this.data.item.id, color);
    this.$emit('item_color_updated');
  }

}
